import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import defaultsDeep from 'lodash/defaultsDeep';
import get from 'lodash/get';
import { modalContentInfoActions as ModalContentInfoActions } from '../../../modals/ModalManageContentInfo';
import AddContentPanel from './AddContentPanel';
import TablePanelView from '../common/TablePanelView';
import { LOGIN_SET_THEME, CALCULATE_FONT_USAGE, REFRESH_SELECTED_THEME_FILE } from '../../../../constants/ActionTypes';
import { checkPermissions } from '../../../../../lib/utils';
import { ThemeService, saveThemeCodeToFrontman } from '../../../../services/ThemeService';
import { SAVE_LEVEL } from '../../../../constants/Level';
import { filterThemeUniqueGlobal } from '../../../../constants/uniqueKeyToGlobalMap';
import { themeSystemDefault } from '../../../../constants/SystemDefaults';
import { ACCESS_POINTS_GROUP } from '../../../../constants/AccessPoints';
import { THEME_CATEGORY } from '../../../../constants/ThemeCategories';
import EditTheme from '../editTheme';
import { isEmpty } from 'lodash';

class ManageTheme extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            code: '',
            comments: '',
            selectedTheme: '',
            selectedConfig: '',
            isValidationShown: false
        };
        this.copyTheme = this.copyTheme.bind(this);
        this.showValidation = this.showValidation.bind(this);
    }

    componentDidMount() {
        if (!isEmpty(this.props.themeList)) {
            this.setSelected(this.props.themeList[0].ContentCode);
        }
    }

    setName(input) {
        this.setState({ name: input });
    }

    setCode(input) {
        this.setState({ code: input });
    }

    setComments(input) {
        this.setState({ comments: input });
    }

    setSelected(input) {
        this.setState({ selectedTheme: input });
    }

    clearComments() {
        this.setState({ comments: '', name: '', isValidationShown: false });
    }

    clearCode() {
        this.setState({ code: '' });
    }

    copyTheme(source) {
        const { code } = this.state;
        if (this.state.name && this.state.code) {
            const detailPromise =
                source.level === SAVE_LEVEL.SYSTEM
                    ? ((source.ContentCode === 'systemdefault-sbem' || source.isSbemTheme)
                        ? ThemeService.systemdefaultSbem() 
                        : ThemeService.systemdefault())
                    : ThemeService.get(
                          this.props.chain.Id,
                          this.props.selectedHotel.id,
                          source.ContentCode,
                          source.level,
                          source.isSbemTheme ? THEME_CATEGORY.SBEM : THEME_CATEGORY.SBE
                      ).then(response => response.data.BEDesignerResult.Value.Data);
            detailPromise.then(theme => {
                const isFromSbemTheme = source.ContentCode === 'systemdefault-sbem' || 
                                       (source.isSbemTheme === true);
                
                const combinedObj = {
                    Data: isFromSbemTheme 
                        ? theme  // SBEM themes use data as-is
                        : filterThemeUniqueGlobal(defaultsDeep(theme, themeSystemDefault)),
                    MetaData: {
                        Comment: this.state.comments,
                        Name: this.state.name
                    }
                };
                const saveMethod = isFromSbemTheme ? ThemeService.newSbem : ThemeService.new;
                saveMethod(
                    this.props.chain.Id,
                    this.props.selectedHotel.id,
                    this.state.code,
                    combinedObj,
                    this.props.level
                ).then(response => {
                    saveThemeCodeToFrontman({
                        code,
                        chainId: this.props.chain.Id,
                        hotelId: this.props.selectedHotel.id,
                        saveLevel: this.props.level,
                        name: get(combinedObj, 'MetaData.Name')
                    });
                    ThemeService.reload(
                        this.props.chain.Id, 
                        this.props.selectedHotel.id, 
                        this.props.level,
                        undefined,
                        false,
                        isFromSbemTheme ? THEME_CATEGORY.SBEM : THEME_CATEGORY.SBE
                    );
                });
                this.clearComments();
                this.clearCode();
                this.setState({ name: '' });
            });
        }
    }

    showValidation() {
        this.setState({ isValidationShown: true });
    }

    render() {
        const themeList = this.props.themeList ? this.props.themeList : [];
        const configList = this.props.configList ? this.props.configList : [];
        let themeOptions = [];
        themeList.length > 0
            ? themeList.map(elem => {
                  themeOptions.push({
                      key: elem.ContentCode,
                      label: elem.ContentCode
                  });
              })
            : (themeOptions = this.props.themelevel.availableThemes);
        let configOptions = [];
        configList.length > 0
            ? configList.map(elem => {
                  configOptions.push({
                      key: elem.ContentCode,
                      label: elem.ContentCode
                  });
              })
            : (configOptions = this.props.themelevel.availableThemes);
        const defaultContentCode = this.props.defaultContent ? this.props.defaultContent : false;

        const inContextThemes = themeList.filter(theme => theme.isSbemTheme);
        const hostedThemes = themeList.filter(theme => !theme.isSbemTheme);

        if (/edit-theme$/.test(this.props.location.pathname)) {
            return <EditTheme currentTheme={this.props.currentTheme} themeCode={this.props.code} />;
        }
        return (
            <main className="spark-main ManageTheme">
                <div className="col-xs-12">
                    {(this.props.permissionTheme.view || this.props.permissionTheme.edit) && (
                        <TablePanelView
                            id="themes-panel"
                            clearComments={this.clearComments.bind(this)}
                            clearCode={this.clearCode.bind(this)}
                            defaultContent={defaultContentCode}
                            chain={this.props.chainid}
                            hotel={this.props.selectedHotel.id}
                            hostedContent={hostedThemes}
                            inContextBeta={this.props.inContextBeta}
                            inContextContent={inContextThemes}
                            setData={this.props.setTheme}
                            onBeforeUpload={this.props.onBeforeUpload}
                            contenttype={ACCESS_POINTS_GROUP.THEMES}
                            itemName="Theme"
                            uploadUrl="manage-theme/edit-theme"
                            onSubmit={this.copyTheme}
                            showValidation={this.showValidation}
                            headline="Themes (styles)"
                            buttonComment="Add a new Theme"
                            code={this.state.code}
                            name={this.state.name}
                            onShowInfo={this.props.showModalInfo}
                        >
                            <AddContentPanel
                                selected={this.props.themelevel.selected}
                                population={this.props.themelevel.population}
                                hotels={this.props.themelevel.hotels}
                                availableThemes={themeOptions}
                                onDispatch={this.props.onThemeDispatch}
                                setName={this.setName.bind(this)}
                                setCode={this.setCode.bind(this)}
                                setComments={this.setComments.bind(this)}
                                setSelected={this.setSelected.bind(this)}
                                comments={this.state.comments}
                                code={this.state.code}
                                name={this.state.name}
                                isValidationShown={this.state.isValidationShown}
                            />
                        </TablePanelView>
                    )}
                    <hr />
                </div>
            </main>
        );
    }
}

ManageTheme.propTypes = {
    children: PropTypes.element,
    onThemeDispatch: PropTypes.func,
    onConfigDispatch: PropTypes.func
};

const mapStateToProps = state => {
    return {
        chainid: state.app.selected.chain.Id,
        ...state.app.data.manage.manage,
        ...state.manage,
        ...state.app.selected,
        permissionTheme: checkPermissions(state, ACCESS_POINTS_GROUP.THEMES),
        inContextBeta: get(state, 'app.selected.inContextBeta')
    };
};

const mapDispatchToProps = dispatch => {
    return {
        showModalInfo: contentData => {
            dispatch(ModalContentInfoActions.show(contentData));
        },
        setTheme: (theme, code, isSbemTheme = false) => {
            dispatch({ type: REFRESH_SELECTED_THEME_FILE });
            dispatch({ type: LOGIN_SET_THEME, theme, code, isSbemTheme });
            dispatch({ type: CALCULATE_FONT_USAGE });
        },
        onBeforeUpload: () => {
            dispatch({ type: REFRESH_SELECTED_THEME_FILE });
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ManageTheme);



// WEBPACK FOOTER //
// ./src/components/pages/manage/manageTheme/index.js